import router from './router'
import {getCookie} from './utils/auth'
import {checkToken} from './api/index'

const whiteList = ['/login', '/404', '/members', '/mbinfo', '/mblogin'];

router.beforeEach(async (to, from, next) => {
    // delCookie("fwUser")
    let fwUser = null
    if (getCookie('fwUser')) {
        fwUser = JSON.parse(getCookie('fwUser'))
    }
    if (fwUser && fwUser.token) {
        // 已登录且要跳转的页面是登录页
        if (to.path === '/login') {
            next({path: '/home'})
        } else {
            next()
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
        } else {
            next('/login') // 否则全部重定向到登录页
        }
    }
})